import { useFeatureFlag } from '@src/hooks/useFeatureFlag';
import type { AssetLeaderboardPanelConfig } from '@src/types/LayoutConfig';
import { useEffect } from 'react';
import { Panel } from '../../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../../types';
import { PanelBlotterTableStorageProvider } from '../../Trading/blotters/PanelBlotterTableStorageProvider';
import { AssetLeaderboardModule } from './AssetLeaderboardModule';

const DEFAULT_TITLE = 'Asset Leaderboard';

export function AssetLeaderboardPanel({ api, params }: LayoutPanelProps<AssetLeaderboardPanelConfig>) {
  const { enableSignals } = useFeatureFlag();

  // Mirror the default title onto the dockview tab unless the user has renamed it via the tab
  // context menu (which sets customTitle on DefaultTabComponent).
  useEffect(() => {
    if (params.customTitle) {
      return;
    }
    if (api.title !== DEFAULT_TITLE) {
      api.setTitle(DEFAULT_TITLE);
    }
  }, [api, params.customTitle]);

  if (!enableSignals) {
    return null;
  }

  return (
    <Panel
      panelApi={api}
      position="relative"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      data-testid="asset-leaderboard-panel"
    >
      <PanelBlotterTableStorageProvider panelApi={api} panelBlottersState={params.blotterTablesState}>
        <AssetLeaderboardModule blotterID={api.id} />
      </PanelBlotterTableStorageProvider>
    </Panel>
  );
}
